// UMARI — Theme JavaScript

document.addEventListener('DOMContentLoaded', () => {

  // ---- HEADER SCROLL ----
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // ---- ACCORDION ----
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ---- CART COUNT UPDATE ----
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count-badge').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  // ---- ADD TO CART ----
  const addToCartForms = document.querySelectorAll('[data-add-to-cart-form]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart-btn]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      const formData = new FormData(form);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity') || 1)
          })
        });
        if (response.ok) {
          btn.textContent = 'Added ✓';
          updateCartCount();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        }
      } catch (err) {
        btn.textContent = originalText;
        btn.disabled = false;
      }
    });
  });

  // ---- VARIANT SELECTION ----
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-buttons');
      group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const form = btn.closest('[data-add-to-cart-form]');
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = btn.dataset.variantId;
      }
    });
  });

  // ---- CART QTY ----
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const item = btn.closest('.cart-item');
      const line = item?.dataset.line;
      const change = btn.dataset.action === 'increase' ? 1 : -1;
      const qtyEl = item?.querySelector('.qty-num');
      if (!line || !qtyEl) return;

      const newQty = Math.max(0, parseInt(qtyEl.textContent) + change);
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line), quantity: newQty })
      });
      if (response.ok) window.location.reload();
    });
  });

// ---- MOBILE MENU ----
const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
const mobileMenu = document.querySelector('.mobile-menu');
if (mobileMenuBtn && mobileMenu) {
  mobileMenuBtn.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('open');
    document.body.classList.toggle('menu-open');
    mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    mobileMenuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
}

  // ---- FADE IN ON SCROLL ----
  const fadeEls = document.querySelectorAll('.fade-in');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  fadeEls.forEach(el => observer.observe(el));

  // ---- GALLERY THUMBS ----
  document.querySelectorAll('.product-gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      gallery.querySelectorAll('.product-gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const main = gallery.querySelector('.product-gallery-main img');
      if (main && thumb.dataset.src) main.src = thumb.dataset.src;
    });
  });

});
